import { IDataProvider } from "@/store";
import { DocumentReportListItem } from "@/types/report/ReportTypes";

export interface IReportState {
  report: DocumentReportListItem | null;
  reports: DocumentReportListItem[] | null;
  dataProvider: IDataProvider<DocumentReportListItem>;
}

export const state: IReportState = {
  report: null,
  reports: null,
  dataProvider: {
    items: [],
    pager: {
      buttonsToShow: 3,
      currentPage: 1,
      endPage: 1,
      startPage: 1,
      totalPages: 1,
    },
  },
};
